import apiClient from '@src/api/clients';

const BASE_URL = 'dashboard/feed-health/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

// Staff feed & backend-data health board. params: { problems_only: bool }.
export const fetchFeedHealth = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export default { fetchFeedHealth };
